// Simple persistent "Ad Copy Clipboard" — collects headlines/descriptions
// the user pins via "Copy to Ad Builder" so they can drop them into the
// Campaign Builder wizard later.
//
// Storage: localStorage key "mb_ad_clipboard"
// Shape: Array<{ id, text, kind, angle, saved_at, source_domain?, source_keyword? }>

const KEY = "mb_ad_clipboard";
const EVENT = "mb_ad_clipboard_change";

const safeParse = (raw) => {
    try {
        const arr = JSON.parse(raw || "[]");
        return Array.isArray(arr) ? arr : [];
    } catch {
        return [];
    }
};

export const readAdClipboard = () => {
    if (typeof window === "undefined") return [];
    return safeParse(window.localStorage.getItem(KEY));
};

const writeAdClipboard = (list) => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new Event(EVENT));
};

export const pushAdClipboard = ({
    text,
    kind,
    angle,
    source_domain,
    source_keyword,
}) => {
    const clean = (text || "").trim();
    if (!clean) return null;
    const list = readAdClipboard();
    // De-dupe on (text, kind, angle) — same phrase pinned twice is a no-op.
    const dupe = list.find(
        (i) => i.text === clean && i.kind === kind && i.angle === angle
    );
    if (dupe) {
        writeAdClipboard(list); // still fire event so counters refresh
        return dupe;
    }
    const item = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        text: clean,
        kind,
        angle: angle || null,
        source_domain: source_domain || null,
        source_keyword: source_keyword || null,
        saved_at: new Date().toISOString(),
    };
    writeAdClipboard([item, ...list].slice(0, 200));
    return item;
};

export const removeAdClipboard = (id) => {
    writeAdClipboard(readAdClipboard().filter((i) => i.id !== id));
};

export const clearAdClipboard = () => writeAdClipboard([]);

// Subscribe to changes (fires on the same tab and cross-tab via 'storage').
export const subscribeAdClipboard = (fn) => {
    if (typeof window === "undefined") return () => {};
    const handler = () => fn(readAdClipboard());
    window.addEventListener(EVENT, handler);
    window.addEventListener("storage", (e) => {
        if (e.key === KEY) handler();
    });
    return () => {
        window.removeEventListener(EVENT, handler);
    };
};
